import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import { Button } from '@agconnections/grow-ui';
import CropZoneIcon from 'assets/crop_zone_primary.svg';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import { useStore } from 'components/Store';
import SelectPropertiesDrawerV2 from 'components/SelectPropertiesDrawerV2';
import SelectPropertiesDrawer from './components/SelectPropertiesDrawer';
import useLoadsFilterSelectionAdapter from './hooks/useLoadsFilterSelectionAdapter';

const SelectPropertiesFilter = ({ hideClearButton }) => {
  const flags = useFlags();
  const {
    state: { organization }
  } = useStore();
  const showNewSelectPropertiesDrawer = featureFlagRenderItem(
    flags.releaseFeNewPropertiesDrawer,
    flags.releaseFeNewPropertiesDrawerByOrg,
    organization?.id
  );

  const [openDrawer, setOpenDrawer] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const count = values?.cropZones?.length || 0;
  const selectionAdapter = useLoadsFilterSelectionAdapter();

  const onReset = () => {
    setFieldValue('cropZones', []);
    setFieldValue('totalAcres', null);
    setFieldValue('totalArea', null);
    setFieldValue('sources', []);
    setFieldValue('sourceType', null);
  };

  return (
    <>
      <div className="flex justify-center gap-4">
        <Button
          ghost
          type="primary"
          className="w-full"
          onClick={() => setOpenDrawer(true)}
          icon={<img src={CropZoneIcon} alt="cropzone icon" />}
        >
          Select Properties
        </Button>
        {!hideClearButton && (
          <Button
            type="outline"
            onClick={onReset}
            className="w-full"
            disabled={!count}
          >
            Clear Selections
          </Button>
        )}
      </div>
      {openDrawer &&
        (showNewSelectPropertiesDrawer ? (
          <SelectPropertiesDrawerV2
            open
            onClose={() => setOpenDrawer(false)}
            selectionAdapter={selectionAdapter}
          />
        ) : (
          <SelectPropertiesDrawer open onClose={() => setOpenDrawer(false)} />
        ))}
    </>
  );
};

SelectPropertiesFilter.defaultProps = {
  hideClearButton: false
};

SelectPropertiesFilter.propTypes = {
  hideClearButton: PropTypes.bool
};

export default SelectPropertiesFilter;
